import React from "react";
import AddUsaEmployee from "./addUsaEmployee/addUsaEmployee";

const UsaEmployeeInviteForm = () => {
  return <AddUsaEmployee isInvite={true} />;
};

export default UsaEmployeeInviteForm;
